import { CustomTextField } from '../../../../../components/CustomTextField';
import { CustomSwitch } from '../../../../../components/CustomSwitch';
import CustomAddChipSearch from '../../../../../components/CustomAddChipSearch';
import React from 'react';
import { USER_TYPE_MODEL } from '../../../../../enums/userTypeEnum';
import ButtonIcon from '../../../../../components/buttons/ButtonIcon';
import {CleanIcon, PersonChipBlack} from '../../../../../components/buttons/IconButtons';
import {userListToLabelEmailPhoneValue} from "../../../../../Apis/functions";

/**
 * @Author: Cecilia López Martínez
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 *
 */
const ReservationsDetails = (
    {
        t, eventDetail, handleChange, emptyFields,
        selectedList, setSelectedList,
        handleClearSteps
    }
) => {

    return (
        <>
            {(eventDetail.id === null || eventDetail.id === '') && (
                <div className='col-12 d-flex justify-content-end mb-2'>
                    <ButtonIcon
                        className='btn-clean-secondary-600'
                        id='btn_rd_clean_form'
                        Icon={CleanIcon}
                        title={'clear_instances'}
                        onClick={() => {
                            handleClearSteps();
                        }}
                    />
                </div>
            )}
            <div className={'col-12'}>
                <CustomTextField
                    id={'slt_rd_event_name'}
                    length={128}
                    name={'name'}
                    value={eventDetail.name}
                    trans={'name'}
                    type={'text'}
                    onChange={handleChange}
                    emptyFields={emptyFields}
                    required={true}
                />
            </div>
            <div className='col-4 mb-1'>
                <CustomSwitch
                    id="cb_rd_host"
                    trans={t('i_am_the_host')}
                    name="isHost"
                    checked={eventDetail?.isHost}
                    onChange={(e) => {
                        handleChange({ target: { name: e.target.name, value: !eventDetail.isHost } })
                    }}
                />
            </div>
            <div className='col-12 my-4'>
                <CustomAddChipSearch
                    id="txt_rd_search_host"
                    selectedList={selectedList}
                    setSelectedList={setSelectedList}
                    userTypeIdsSearch={[USER_TYPE_MODEL.EMPLOYEE]}
                    disabled={eventDetail?.isHost}
                    label="assign_a_host"
                    emptyFields={emptyFields && !eventDetail?.isHost}
                    required={!eventDetail?.isHost}
                    reset={false}
                    keyId={"userId"}
                    showSubSection={true}
                    sanitizeDataList={userListToLabelEmailPhoneValue}
                    Icon={PersonChipBlack}
                />
            </div>
        </>
    )
}


export default ReservationsDetails
